import { ArenaOpsUsdtSchema } from "./arena-ops-filters.dto";
import { z } from "zod";

export const ArenaOpsMoneyWithdrawalRequestRowSchema = z.object({
  id: z.number().int(),
  hubUserId: z.number().int(),
  amountUsdt: ArenaOpsUsdtSchema,
  status: z.string(),
  /** Epoch id `0` is valid — compare `== null`, never falsiness. */
  epochId: z.number().int().nullable(),
  cooldownEnd: z.iso.datetime().nullable(),
  claimedAt: z.iso.datetime().nullable(),
  createdAt: z.iso.datetime(),
});

/** P8 — the paginated request list. Keyset on `id DESC`. */
export const ArenaOpsMoneyWithdrawalRequestsResponseSchema = z.object({
  rows: z.array(ArenaOpsMoneyWithdrawalRequestRowSchema),
  nextCursor: z.string().nullable(),
  totalUsdt: ArenaOpsUsdtSchema,
});
export type ArenaOpsMoneyWithdrawalRequestsResponse = z.infer<typeof ArenaOpsMoneyWithdrawalRequestsResponseSchema>;
